// extracted by mini-css-extract-plugin
export default {"card":"styles_card__W39TN","pulse":"styles_pulse__j4mMO","loaded":"styles_loaded__yPLQC"};